import { $mount } from '../../../js/dom-lifecycle';

const $modal = $('#ajax-action');
const $dialog = $modal.find('.modal-dialog');
const $title = $modal.find('.modal-title');
const $body = $modal.find('.modal-body');
const $footer = $modal.find('.modal-footer');
const dialogBaseClass = $dialog.attr('class');
const loaderHtml = $body.html();

$mount('[data-ajax-action]').on('click', async function (e) {
    e.preventDefault();
    const size = typeof $(this).data('ajax-action') == 'string' ? $(this).data('ajax-action') : $(this).data('modal-size');
    $dialog.attr('class', dialogBaseClass + ' ' + (size || 'modal-xl modal-fullscreen-xl-down'));
    showLoader();
    bootstrap.Modal.getOrCreateInstance($modal[0]).show();
    await handleResponse(await fetch(this.href, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
    }));
});

async function handleResponse(response) {
    const redirectUrl = response.headers.get('X-Redirect');
    if (redirectUrl) {
        bootstrap.Modal.getOrCreateInstance($modal[0]).hide();
        window.location.href = redirectUrl;
        return;
    }
    if (!response.ok) {
        alert(`Błąd ${response.status}`);
        return;
    }

    $body.html(await response.text());
    $title.html($body.find('[data-ajax-action="title"]').html());
    $footer.html($body.find('[data-ajax-action="footer"]').html());
    $footer.toggleClass('d-none', !$footer.html());

    const flash = $body.find('[data-ajax-action="flash"]').html() || '';
    const content = $body.find('[data-ajax-action="content"] .card-body').html()
        || $body.find('[data-ajax-action="content"]').html() || '';
    $body.html(flash + content);

    $modal.find('form').on('submit', submitForm);
}

async function submitForm(e) {
    e.preventDefault();
    const formData = new FormData(this);
    if (e.originalEvent.submitter?.name) {
        formData.append(e.originalEvent.submitter.name, e.originalEvent.submitter.value);
    }
    showLoader(false);
    await handleResponse(await fetch(this.action, {
        method: this.method,
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
    }));
}

function showLoader(resetTitle = true) {
    $body.html(loaderHtml);
    resetTitle && $title.html('&nbsp;');
    $footer.html('').addClass('d-none');
}
